import { Text, YStack, Spinner } from "tamagui";
import { colors } from "@styles/colors";
import type { ApplePayState } from "@hooks/useApplePay";

/**
 * Apple Pay 按鈕：黑底白字，比照 Pay/index.tsx 的 primary 按鈕寫法。
 * state === 'unavailable' 時回 null，由呼叫端決定替代文案（例如改顯示信用卡付款）。
 */
export const ApplePayButton: React.FC<{ state: ApplePayState; onPress: () => void; note?: string }> = ({ state, onPress, note }) => {
  if (state === "unavailable") return null;

  const busy = state === "loading" || state === "paying";

  return (
    <YStack>
      <YStack
        testID="apple-pay-button"
        height={44}
        br={10}
        bg="#000"
        ai="center"
        jc="center"
        opacity={busy ? 0.7 : 1}
        cursor={busy ? "default" : "pointer"}
        pressStyle={busy ? undefined : { opacity: 0.8 }}
        onPress={busy ? undefined : onPress}>
        {busy ? (
          <Spinner size="small" color="#fff" />
        ) : (
          <Text fontSize={17} fontWeight="600" color="#fff" fontFamily={'-apple-system, "SF Pro Text", system-ui'}>
            {" Pay"}
          </Text>
        )}
      </YStack>
      <Text fontSize={11} color={colors.gray ?? "#8a93a6"} textAlign="center" mt="$2">
        {note ?? "將立即付款"}
      </Text>
    </YStack>
  );
};

export default ApplePayButton;
